module.exports = __webpack_public_path__ + "img/ic_website_black.f4ea7af8.svg";